import { openAnnualFollowup } from "@/features/clients/lib/annual-followup-store";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { PrepareAnnualFollowupArgs } from "@/features/intelligence/lib/frontend-tools";
import { shownResult } from "@/features/intelligence/lib/tool-result";

export function prepareAnnualFollowup(
  { ignored }: PrepareAnnualFollowupArgs,
  toolCallId: string,
): HandlerOutcome {
  openAnnualFollowup(toolCallId);
  return shownResult(
    "An annual follow-up card is shown in the chat for the advisor's whole book. It reads the " +
      "clients and their latest signed investment advice itself, so you do not see what it " +
      "lists. Nothing has been created: each row starts an advice only when the advisor clicks it",
    "points to the card; do not list, count or guess its rows, and do not start an advice " +
      "yourself",
    ignored,
  );
}
